import { BuilderState } from '@/types/builder';
import { CategoryLabelVariant } from '../CategoryLabel/CategoryLabel';

export const ARTICLES_LIST_NAME = 'ArticlesList';

export type ShowAs = 'list' | 'cards';

export interface ArticleListInput {
  title?: string;
  showAs?: ShowAs;
  builderState: BuilderState;
  /**
   * Color variant for category tags.
   * - 'primary': Orange (default)
   * - 'secondary': Purple (#59214D) for guides pages
   */
  tagVariant?: CategoryLabelVariant;
}
